import type {
  LineItem,
  Section,
} from 'src/pages/Dashboard/components/DueDiligence/preliminaryDDSchemaTypes';
import { DueDiligenceFormType } from 'src/pages/Dashboard/components/DueDiligence/types';

export enum PreliminaryDDItemStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
}

export enum PreliminaryDDStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  REVIEW_IN_PROGRESS = 'REVIEW_IN_PROGRESS',
  REOPENED = 'REOPENED',
  RECEIVED = 'RECEIVED',
  OVERDUE = 'OVERDUE',
}

export interface PreliminaryDDClientResponse {
  id: string;
  clientCode: string;
  companyName: string;
  templateType: string;
  dueDate: string;
  status: PreliminaryDDStatus;
  createdAt: string;
  updatedAt: string;
  pocEmails: string[];
  sections: Section[];
}

export interface PreliminaryDDUpdateResponse {
  updatedAt: string;
}

export interface PreliminaryDueDiligenceTemplate {
  id: string;
  templateType: string;
  name: string;
  sections: Section[];
}

export interface CreatePreliminaryDueDiligencePayload {
  clientCode: string;
  templateType: string;
  dueDate: string;
  sections: Section[];
  pocEmails: string[];
}

export interface UpdatePreliminaryDDClientItemsPayload {
  items: LineItem[];
}

export interface PreliminaryDueDiligenceListParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  status?: PreliminaryDDStatus;
  attentionRequired?: boolean;
  sortOrder?: 'ASC' | 'DESC';
  sort?: 'createdAt' | 'dueDate' | 'status';
}

export interface PreliminaryDueDiligenceListItem {
  id: string;
  clientCode: string;
  companyName: string;
  templateType: string;
  createdAt: string;
  dueDate: string;
  status: PreliminaryDDStatus;
  adminAttentionCount: number;
}

export interface PreliminaryDueDiligenceListResponse {
  totalPages: number;
  totalElements: number;
  items: PreliminaryDueDiligenceListItem[];
}

export interface PreliminaryDueDiligenceClientSummary {
  id: string;
  clientCode: string;
  companyName: string;
  dueDiligenceType: DueDiligenceFormType.PRELIMINARY;
}

export interface PreliminaryDueDiligenceAvailableCompany {
  id: string;
  name: string;
  clientCode: string;
  address: string;
  companyHQ: string;
}

export interface PreliminaryDueDiligenceItemAttachmentResponse {
  attachmentId: string;
  fileName: string;
}

export interface UpdatePreliminaryDDItemStatusPayload {
  itemId: string;
  status: PreliminaryDDItemStatus;
}

export interface PreliminaryDDCreateConversationPayload {
  itemId: string;
  commentText: string;
  internal: boolean;
}

export interface PreliminaryDDEditConversationPayload {
  itemId: string;
  conversationId: string;
  commentText: string;
}

export interface PreliminaryDDDeleteConversationPayload {
  itemId: string;
  conversationId: string;
}
